// Class removal utility
const stripClass = (className) => {
  const bodyClasses = document.body.classList;
  if (bodyClasses.contains(className)) {
    bodyClasses.remove(className);
  }
}

export default stripClass;
